export const getStep = state => state.setupMFAWebAuthn.step
export const getErrorCode = state => state.setupMFAWebAuthn.errorCode
export const getIsProcessing = state => state.setupMFAWebAuthn.isProcessing
export const getWebAuthnCredential = state => state.setupMFAWebAuthn.credential
export const getWebAuthnRegistrationData = state =>
  state.setupMFAWebAuthn.registrationData
